module.exports = __webpack_public_path__ + "media/customizations/delwebbfulshear/back-5871b7df58d179ed5c0e72201f0bde76.jpg";